import { FC } from 'react';
import { CustomContainer } from 'components/CustomContainer';
import getRunningBrowserOS from 'helpers/getRunningBrowserOS';
import availableShortcuts from './availableShortCuts';
import ShortcutsList from './ShortcutsList';

const MAX_ROWS = 4;
const COLUMN_SPACING = 4;
const COLUMN_SPACING_PX = COLUMN_SPACING * 8;

const Shortcuts: FC = () => {
  const browserOS = getRunningBrowserOS();

  const MAX_COLUMNS = Math.ceil(availableShortcuts.length / MAX_ROWS);

  return (
    <CustomContainer
      alignItems="stretch"
      columnSpacing={COLUMN_SPACING}
      display="grid"
      gridAutoFlow="column"
      gridTemplateColumns={`repeat(${MAX_COLUMNS}, 1fr)`}
      gridTemplateRows={`repeat(${MAX_ROWS}, auto)`}
      pb={5}
      position="relative"
      rowSpacing={3}
      sx={theme => ({
        '& .column-divider': {
          backgroundColor: '#eeeeee',
          bottom: 0,
          pointerEvents: 'none',
          position: 'absolute',
          top: 0,
          transform: `translateX(-${COLUMN_SPACING_PX / 2}px)`,
          width: '1px',
        },

        [theme.breakpoints.down('md')]: {
          gridAutoFlow: 'row',
          gridTemplateColumns: '1fr',
          gridTemplateRows: 'auto',
          columnGap: 0,

          '& .column-divider': {
            display: 'none',
          },
        },
      })}>
      {/* Dividers */}
      {Array.from({ length: MAX_COLUMNS - 1 }).map((_, idx) => {
        const totalGaps = (MAX_COLUMNS - 1) * COLUMN_SPACING_PX;

        const colWidth = `calc((100% - ${totalGaps}px) / ${MAX_COLUMNS})`;

        return (
          <div
            key={`${idx}-divider`}
            className="column-divider"
            style={{
              left: `calc((${colWidth} + ${COLUMN_SPACING_PX}px) * ${idx + 1})`,
            }}
          />
        );
      })}

      <ShortcutsList browserOS={browserOS} shortcuts={availableShortcuts} />
    </CustomContainer>
  );
};

export default Shortcuts;
